export const INVALID_FILETYPE = 'INVALID_FILETYPE';
export const SERVER_TOKEN = process.env.SERVER_TOKEN;
export const SERVER_TZ = process.env.NEXT_PUBLIC_TZ || 'America/New_York';
